document.addEventListener('alpine:init', () => {
    Alpine.data('menuDrawer', () => ({
        isActive: false,
        init() {
        },
        openDrawer() {
            document.querySelector('html').classList.add('overflow-hidden');
        },
        closeDrawer() {
            document.querySelector('html').classList.remove('overflow-hidden');
        }
    }
    ))
})
